import managementRedirect from 'src/router/middleware/management/managementRedirect.js'
import auth from 'src/router/middleware/authentification/auth.js'

const GenerateUsersManual = () => import('src/views/Management/Users/GenerateUsersManual.vue')
const SchoolDataWrapper = () => import('src/views/Management/Schools/Views/SchoolDataWrapper.vue')
const ManagementData = () => import('src/views/Management/Basedata/Basedata.vue')

const Wrapper = () => import('src/views/Management/Onboarding/OnboardingWrapper.vue')
const Start = () => import('src/views/Management/Onboarding/OnboardingStart.vue')
const EditSchool = () => import('src/views/Management/Schools/Views/EditSchool.vue')
const EditSchoolBilling = () => import('src/views/Management/Schools/Views/EditSchoolBilling.vue')

const WebInterfaceWrapper = () => import('src/views/Management/TimteableUploader/TimetableUploaderWrapper.vue')
const AdminTimetableWebInterfaceAutomatic = () => import('src/views/Management/TimteableUploader/TimetableUploaderAutomatic.vue')
const AdminTimetableWebInterface = () => import('src/views/Management/TimteableUploader/TimetableUploaderInterface.vue')

const GenerateUsersWrapper = () => import('src/views/Management/Onboarding/OnboardingGenerateUsersWrapper.vue')
const GenerateUsersUpload = () => import('src/views/Management/Users/GenerateUsersUpload.vue')
const UserUploadSuccess = () => import('src/views/Management/Onboarding/OnboardingUserUploadSuccess.vue')
const BookCallToSupport = () => import('src/views/Management/Onboarding/OnboardingBookCallToSupport.vue')
const Summary = () => import('src/views/Management/Onboarding/OnboardingSummary.vue')

const forceOpenVideos = true

export default [
  {
    path: '/onboarding/:schoolUuid',
    component: Wrapper,
    name: 'onboarding-wrapper',
    meta: {
      middleware: [auth, managementRedirect],
      switchManagementData: true,
      headerText: 'global.headers.school_onboarding'
    },
    children: [
      {
        path: 'start',
        component: Start,
        name: 'onboarding-start',
        meta: {
          step: 0,
          ignoreWrapper: true,
          switchManagementData: true,
          headerText: 'global.headers.school_onboarding'
        }
      },
      {
        path: 'school-data',
        name: 'onboarding-school-data-wrapper',
        component: SchoolDataWrapper,
        meta: {
          middleware: [auth],
          group: 'school',
          switchManagementData: true,
          headerText: 'global.headers.school_onboarding'
        },
        children: [
          {
            path: 'edit-school',
            component: EditSchool,
            name: 'onboarding-edit-school',
            meta: {
              step: 1,
              onboarding: true,
              onboardingHeader: 'onboarding.schoolData.header',
              hint: 'onboarding.schoolData.hint',
              video: {
                url: 'onboarding.schoolData.video',
                forceOpen: forceOpenVideos
              },
              switchManagementData: true,
              headerText: 'global.headers.school_onboarding'
            }
          },
          {
            path: 'edit-school-billing',
            component: EditSchoolBilling,
            name: 'onboarding-edit-school-billing',
            meta: {
              step: 2,
              onboarding: true,
              onboardingHeader: 'onboarding.schoolData.header',
              video: {
                url: 'onboarding.schoolData.video',
                forceOpen: forceOpenVideos
              },
              switchManagementData: true,
              headerText: 'global.headers.school_onboarding'
            }
          }
        ]
      },
      {
        path: 'web-interface',
        component: WebInterfaceWrapper,
        name: 'onboarding-web-interface-wrapper',
        meta: {
          middleware: [auth, managementRedirect],
          switchManagementData: true,
          headerText: 'global.headers.school_onboarding'
        },
        children: [
          {
            path: 'automatic-upload',
            component: AdminTimetableWebInterfaceAutomatic,
            name: 'onboarding-web-interface-auto',
            meta: {
              step: 2,
              onboarding: true,
              onboardingHeader: 'onboarding.webInterface.header',
              hint: 'onboarding.webInterface.hint',
              video: {
                url: 'onboarding.webInterface.video',
                forceOpen: forceOpenVideos
              },
              switchManagementData: true,
              preventScrollTop: true,
              headerText: 'global.headers.school_onboarding'
            }
          },
          {
            path: 'upload',
            component: AdminTimetableWebInterface,
            name: 'onboarding-web-interface',
            meta: {
              step: 2,
              onboarding: true,
              onboardingHeader: 'onboarding.webInterfaceAuto.header',
              hint: 'onboarding.webInterfaceAuto.hint',
              video: {
                url: 'onboarding.webInterfaceAuto.video'
              },
              switchManagementData: true,
              preventScrollTop: true,
              headerText: 'global.headers.school_onboarding'
            }
          }
        ]
      },
      {
        path: 'users',
        component: GenerateUsersWrapper,
        name: 'generate-users-wrapper',
        children: [
          {
            path: 'import',
            component: GenerateUsersUpload,
            name: 'onboarding-import-users',
            meta: {
              step: 3,
              skipHistory: true,
              onboarding: true,
              onboardingHeader: 'onboarding.generateUsers.header',
              hint: 'onboarding.generateUsers.hint',
              video: {
                url: 'onboarding.generateUsers.video',
                forceOpen: forceOpenVideos
              },
              switchManagementData: true,
              preventScrollTop: true,
              headerText: 'global.headers.school_onboarding'
            }
          },
          {
            path: 'generate',
            component: GenerateUsersManual,
            name: 'onboarding-generate-users',
            meta: {
              step: 3,
              skipHistory: true,
              onboarding: true,
              onboardingHeader: 'onboarding.generateUsersManual.header',
              hint: 'onboarding.generateUsersManual.hint',
              video: {
                url: 'onboarding.generateUsersManual.video'
              },
              switchManagementData: true,
              preventScrollTop: true,
              headerText: 'global.headers.school_onboarding'
            }
          },
          {
            path: 'user-upload-success',
            component: UserUploadSuccess,
            name: 'onboarding-user-upload-success',
            meta: {
              onboarding: true,
              hint: 'onboarding.generateUserSuccess.hint',
              switchManagementData: true,
              headerText: 'global.headers.school_onboarding'
            }
          }
        ]
      },
      {
        path: 'basedata/:entity',
        component: ManagementData,
        name: 'onboarding-basedata',
        meta: {
          onboarding: true,
          hint: 'onboarding.ManagementData.hint',
          switchManagementData: true,
          video: {
            url: 'onboarding.ManagementData.video',
            forceOpen: forceOpenVideos
          },
          headerText: 'global.headers.school_onboarding'
        }
      },
      {
        path: 'book-call',
        component: BookCallToSupport,
        name: 'onboarding-book-call',
        meta: {
          hint: 'onboarding.book_call.hint',
          ignoreWrapper: false,
          video: {
            url: 'onboarding.book_call.video',
            forceOpen: forceOpenVideos
          },
          switchManagementData: true,
          headerText: 'global.headers.school_onboarding'
        }
      }
    ]
  },
  {
    path: '/onboarding-success',
    component: Summary,
    name: 'onboarding-success',
    meta: {
      video: {
        url: 'onboarding.summary.video'
      },
      switchManagementData: true,
      headerText: 'global.headers.school_onboarding'
    }
  }
]
